import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import LoginScreen from './components/LoginScreen'
import Dashboard from './components/Dashboard'
import Meetings from './components/Meetings'
import Members from './components/Members'
import Settings from './components/Settings'
import UserProfile from './components/UserProfile'
import VoteTap from './components/VoteTap'
import BeerLibrary from './components/BeerLibrary'
import Documents from './components/Documents'
import Layout from './components/Layout'
import { PollProvider } from './contexts/PollContext'

type AuthState = 'checking' | 'authenticated' | 'unauthenticated'

function App() {
  const [authState, setAuthState] = useState<AuthState>('checking')

  useEffect(() => {
    fetch('/api/auth/verify', { credentials: 'include' })
      .then(async res => {
        if (res.ok) {
          const { isAdmin, _id } = await res.json() as { isAdmin: boolean; _id?: string }
          const stored = localStorage.getItem('user')
          if (stored) {
            localStorage.setItem('user', JSON.stringify({ ...JSON.parse(stored), isAdmin, _id }))
          }
          setAuthState('authenticated')
        } else {
          setAuthState('unauthenticated')
        }
      })
      .catch(() => setAuthState('authenticated'))
  }, [])

  if (authState === 'checking') return null

  const isLoggedIn = authState === 'authenticated'

  return (
    <Router>
      {isLoggedIn ? (
        <PollProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/login"       element={<Navigate to="/" replace />} />
              <Route path="/"            element={<Dashboard />} />
              <Route path="/meetings"    element={<Meetings />} />
              <Route path="/members"     element={<Members />} />
              <Route path="/settings"    element={<Settings />} />
              <Route path="/members/:id" element={<UserProfile />} />
              <Route path="/votes"       element={<VoteTap />} />
              <Route path="/beers"       element={<BeerLibrary />} />
              <Route path="/documents"   element={<Documents />} />
            </Route>
          </Routes>
        </PollProvider>
      ) : (
        <Routes>
          <Route path="*" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginScreen />} />
        </Routes>
      )}
    </Router>
  )
}

export default App
